/**
 * This helper function is used to convert a target entity based on its id inside a map function.
 * @param targetId The id to use for finding the right target entity
 * @param mapFunction The function will be called with the target entity as input. Will output a mapped version of the target entity.
 * @param idKey The key to use for comparing the targetId with the entity id. Default is 'id'
 */
const mapTarget =
    <T extends object>(
        targetKey: keyof T,
        targetValue: T[typeof targetKey],
        mapFunction: (entityToMap: T) => T
    ) =>
    (entity: T): T => {
        if (!(targetKey in entity)) return entity; // Ensure targetKey exists on the entity
        if (entity[targetKey] !== targetValue) return entity; // Not the one we are looking for

        return mapFunction(entity);
    };

export { mapTarget };
